module.exports = __webpack_public_path__ + "static/img/kjdy10.8134df5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/kjdy10.png
// module id = 133
// module chunks = 0